import * as React from 'react'
import { ReactElement, useEffect, useState } from 'react'
import { ActionButton, DialogFooter, IDialogProps, PrimaryButton, Stack, StackItem } from '@fluentui/react'
import LegacyBaseDialog from '../LegacyBaseDialog'
import DocumentName from '../../Render/DocumentName'
import DocumentDropdown, { DocumentSelectionType } from '../../Dropdown/DocumentDropdown'
import { ComboBoxOption } from '../../Dropdown/BaseDropdown'
import { IFolderOverviewItemDto, IRootOverviewItemDto } from '../../../config/documentConfig'
import { FileDocumentAction } from '../../../config/fileDocumentConfig'
import { useDispatch } from 'react-redux'
import useAxios from '../../../hooks/useAxios'
import BaseList from '../../../components/List/BaseList'
import { uploadDocument } from '../../../helpers/documentHelper'
import { useTranslation } from 'react-i18next'

type Props = IDialogProps & {
    folders: IRootOverviewItemDto
    selectedFolder?: IFolderOverviewItemDto
    documents: File[]
}

export default function ImportDocumentDialog(props: Props): ReactElement {
    const axios = useAxios()
    const dispatch = useDispatch()
    const { t: translate } = useTranslation()

    const [folder, setFolder] = useState<IFolderOverviewItemDto>()

    useEffect(() => {
        setFolder(props.selectedFolder)
    }, [props.selectedFolder])

    return (
        <LegacyBaseDialog
            dialogContentProps={{
                title: translate('file.pivot.document.import.title', { count: props.documents?.length || 1 }),
            }}
            {...props}
        >
            <Stack tokens={{ childrenGap: 's1' }}>
                <StackItem>
                    <BaseList<File> items={props.documents || []}>
                        {(document?: File) => <DocumentName name={document.name} isLink={false} />}
                    </BaseList>
                </StackItem>
                <StackItem>
                    <DocumentDropdown
                        label={translate('file.pivot.document.import.form.folder')}
                        placeholder={translate('file.pivot.document.import.form.folder')}
                        data={props.folders}
                        selectedKey={folder?.id}
                        selectionType={DocumentSelectionType.FolderOnly}
                        onChange={(_, option?: ComboBoxOption<IFolderOverviewItemDto>) => setFolder(option.data)}
                    />
                </StackItem>
            </Stack>
            <DialogFooter>
                <PrimaryButton
                    text={translate('file.pivot.document.import.form.submit', {
                        count: props.documents?.length || 1,
                    })}
                    disabled={!folder}
                    onClick={() => {
                        Promise.all((props.documents || []).map(document => uploadDocument(axios, dispatch, folder.id, document))).then(() =>
                            dispatch({ type: FileDocumentAction.ResetOverview }),
                        )
                        props.onDismiss()
                    }}
                />
                <ActionButton text={translate('action.cancel')} onClick={props.onDismiss} />
            </DialogFooter>
        </LegacyBaseDialog>
    )
}
